import { doDelete, doGet, doPost, doPut } from 'api/request';
import type {
  CreateEditSecretRequest,
  DeleteSecretRequest,
  SecretsManagerResponse,
} from 'api/resources/secretsManager/types';
import { LOGGER_TYPE } from 'api/types';

export const getSecrets = (accountId: string, displayName?: string) =>
  doGet(`accounts/${accountId}/api_secrets`, LOGGER_TYPE.JUPITER, {
    params: {
      name: displayName,
    },
  });

export const createSecret = ({
  accountId,
  body,
}: {
  accountId: string;
  body: CreateEditSecretRequest;
}) => {
  return doPost<SecretsManagerResponse>(
    `accounts/${accountId}/api_secrets`,
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const editSecret = ({
  accountId,
  body,
}: {
  accountId: string;
  body: CreateEditSecretRequest;
}) => {
  return doPut<SecretsManagerResponse>(
    `accounts/${accountId}/api_secrets`,
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const deleteSecret = ({
  accountId,
  body,
}: {
  accountId: string;
  body: DeleteSecretRequest;
}) => {
  return doDelete<SecretsManagerResponse>(
    `accounts/${accountId}/api_secrets`,
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const getApiIntegrationSecrets = (
  accountId: string,
  projectId: string,
  apiId: string,
) =>
  doGet(`accounts/${accountId}/api_secrets`, LOGGER_TYPE.JUPITER, {
    params: {
      name: `api-integration-${projectId}-${apiId}`,
    },
  });

export const getApiIntegrationSecretByName = async (
  accountId: string,
  projectId: string,
  apiId: string,
): Promise<SecretsManagerResponse | null> => {
  const secrets = await getSecrets(
    accountId,
    `api-integration-${projectId}-${apiId}`,
  );
  if (secrets.length > 0) {
    return secrets[0];
  }
  return null;
};

export const createApiIntegrationSecret = ({
  accountId,
  projectId: _projectId,
  apiId: _apiId,
  body,
}: {
  accountId: string;
  projectId: string;
  apiId: string;
  body: CreateEditSecretRequest;
}) => {
  return doPost<SecretsManagerResponse>(
    `accounts/${accountId}/api_secrets`,
    LOGGER_TYPE.JUPITER,
    {
      ...body,
      display_name: `${body.display_name}`,
    },
  );
};

export const updateApiIntegrationSecret = ({
  accountId,
  projectId: _projectId,
  apiId: _apiId,
  body,
}: {
  accountId: string;
  projectId: string;
  apiId: string;
  body: CreateEditSecretRequest;
}) => {
  return doPut<SecretsManagerResponse>(
    `accounts/${accountId}/api_secrets`,
    LOGGER_TYPE.JUPITER,
    {
      ...body,
      display_name: body.display_name,
    },
  );
};

export const deleteApiIntegrationSecret = ({
  accountId,
  projectId: _projectId,
  apiId: _apiId,
  body,
}: {
  accountId: string;
  projectId: string;
  apiId: string;
  body: DeleteSecretRequest;
}) => {
  return doDelete<SecretsManagerResponse>(
    `accounts/${accountId}/api_secrets`,
    LOGGER_TYPE.JUPITER,
    {
      display_name: body.display_name,
    },
  );
};
